const freightUnit = { 1: 'per_trip', 2: 'per_ton', 3: 'per_kg', 4: 'per_cft', 5: 'per_package', 6: 'per_case', 7: 'per_box', 8: 'per_km', 9: 'percentage' };

module.exports = { freightUnit };

